import { useState } from "react";
import { TransferConsentFormUK } from "./TransferConsentFormUK/TransferConsentFormUK";
import { TransferResultMessageUK } from "./TransferResultMessageUK/TransferResultMessageUK";
import { transferState as Transfer } from "./values";

interface TransferConsentPageUKProps {
  transferUrl: string;
  csrfToken: string;
}
/* eslint-disable @typescript-eslint/no-explicit-any */

interface TransferState {
  state: string;
  response: any;
}

export const TransferConsentPageUK = ({
  transferUrl,
  csrfToken,
}: TransferConsentPageUKProps) => {
  const [transferState, setTransferState] = useState<TransferState>({
    state: Transfer,
    response: null,
  });

  return (
    <div>
      {transferState.state === Transfer ? (
        <TransferConsentFormUK
          transferUrl={transferUrl}
          csrfToken={csrfToken}
          transferState={setTransferState}
        />
      ) : (
        <TransferResultMessageUK transferStatus={transferState} />
      )}
    </div>
  );
};
